module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/expediente/expediente.component.css
// module id = ./src/app/components/expediente/expediente.component.css
// module chunks = main